module.exports = __webpack_public_path__ + "20aad13d3d2bb965687226727e4fae9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/violadavis.jpg
// module id = 140
// module chunks = 0